const PRODUCTION_API = 'https://peakperformanceiq.com';

type CapacitorWindow = Window & {
  Capacitor?: {
    isNativePlatform?: () => boolean;
  };
};

/** True inside the Capacitor Android/iOS shell (not mobile browser). */
export function isNativeApp(): boolean {
  if (typeof window === 'undefined') return false;
  const cap = (window as CapacitorWindow).Capacitor;
  return Boolean(cap?.isNativePlatform?.());
}

/** True on the native iOS shell. */
export function isNativeIOS(): boolean {
  if (!isNativeApp()) return false;
  const cap = (window as CapacitorWindow).Capacitor as { getPlatform?: () => string } | undefined;
  return cap?.getPlatform?.() === 'ios';
}

/** Hide AdSense in native apps (App Store compliance). Amazon affiliate picks still show. */
export function showWebMonetization(): boolean {
  return !isNativeApp();
}

/** Partner / Amazon affiliate recommendations (web + native). */
export function showAffiliateOffers(): boolean {
  return true;
}

/** API origin — empty on web (same-origin); production URL in native apps. */
export function apiOrigin(): string {
  const fromEnv = import.meta.env.VITE_API_BASE_URL?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  if (isNativeApp()) return PRODUCTION_API;
  return '';
}

export function resolveApiUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  const origin = apiOrigin();
  return origin ? `${origin}${p}` : p;
}
